module.exports = __webpack_public_path__ + "img/2017.76c5c6a0.jpg";